import { render, staticRenderFns } from "./ConnectionEditTag.vue?vue&type=template&id=31df6e16"
import script from "./ConnectionEditTag.vue?vue&type=script&lang=js"
export * from "./ConnectionEditTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports